import { Link, useLocation } from 'react-router-dom';
import { servicesLinks, industriesLinks, insightsLinks, careersLinks } from '../../../utils/navbarservices';

const enterprise = servicesLinks.enterprise_technologies.links;
const products = servicesLinks.Products.links;
export const navigationMenus = [
  { id: 'services', label: 'Services',
    groups: [{ items: enterprise.serviceGroups }] },
  { id: 'expertise', label: 'What We Do',
    groups: [{ title: 'Consulting services', items: enterprise.subLink2 }, { title: 'ERP platforms', items: enterprise.subLink1 }, { title: 'Our solutions', items: [...products.subLink1, ...products.subLink2] }] },
  { id: 'industries', label: 'Industries',
    groups: [{ items: [...industriesLinks.industries_1.links.subLink1, ...industriesLinks.industries_2.links.subLink1] }] },
  { id: 'insights', label: 'Insights',
    groups: [{ items: insightsLinks.insights_1.links.subLink1 }] },
  { id: 'careers', label: 'Careers',
    groups: [{ title: 'Internal hiring program', items: careersLinks.internalHiringProgram.links }] },
];

export const menuContainsPath = (menu, pathname) => menu.groups.some(group => group.items.some(function matches(item) {
  return pathname === item.link || (item.links || item.subLink || []).some(matches);
}));

const introductions = {
  services: 'Discover our technology services, built to support your business and its changing needs.',
  expertise: 'Connect your platforms, people, and processes with the right expertise.',
  industries: 'Explore solutions shaped around the needs of your industry.',
  insights: 'Get to know KCS Tech and explore our latest ideas and conversations.',
  careers: 'Build your skills and take the next step in your technology career.',
};

function MenuLink({ item, onNavigate, compact = false }) {
  const { pathname } = useLocation();
  return <Link to={item.link} onClick={onNavigate}
    aria-current={pathname === item.link ? 'page' : undefined}
    className={`kcs-menu-link${compact ? ' kcs-menu-link-child' : ''}`}>
    {item.name}
  </Link>;
}

export default function PremiumNavMenu({ menu, onNavigate, mobile = false }) {
  const parents = menu.groups.flatMap(group => group.items).filter(item => (item.links || item.subLink)?.length);
  return <div className={`kcs-mega-menu${mobile ? ' kcs-mega-menu-mobile' : ''}`}>
    {!mobile && <aside className="kcs-menu-intro">
      <h2>{menu.label}</h2>
      <p>{introductions[menu.id]}</p>
      <Link to="/contact" onClick={onNavigate} className="kcs-menu-contact">Talk to our team</Link>
    </aside>}
    <div className={`kcs-menu-content${menu.groups.length > 1 ? ' kcs-menu-content-grouped' : ''}`}>
      <div className="kcs-menu-groups">
        {menu.groups.map((group, index) => <div key={group.title || index}>
          {group.title && <h3 className="kcs-menu-heading">{group.title}</h3>}
          <ul className="kcs-menu-list">
            {group.items.filter(item => mobile || !parents.includes(item)).map(item => <li key={item.link || item.name}>
              {mobile && (item.links || item.subLink)?.length > 0 ? <details className="kcs-menu-disclosure">
                <summary>{item.name}</summary>
                <ul className="kcs-menu-list">
                  <li><MenuLink item={{ name: `${item.name} overview`, link: item.link }} onNavigate={onNavigate} compact /></li>
                  {(item.links || item.subLink).map(child => <li key={child.link}><MenuLink item={child} onNavigate={onNavigate} compact /></li>)}
                </ul>
              </details> : <MenuLink item={item} onNavigate={onNavigate} />}
            </li>)}
          </ul>
        </div>)}
      </div>
      {!mobile && parents.length > 0 && <div className="kcs-menu-related">
        {parents.map(item => <details key={item.link || item.name} className="kcs-menu-disclosure">
          <summary>{item.name}</summary>
          <ul className="kcs-menu-list">
            <li><MenuLink item={{ name: `${item.name} overview`, link: item.link }} onNavigate={onNavigate} compact /></li>
            {(item.links || item.subLink).map(child => <li key={child.link}><MenuLink item={child} onNavigate={onNavigate} compact /></li>)}
          </ul>
        </details>)}
      </div>}
    </div>
  </div>;
}
